import { make, dispatch } from 'vuex-pathify'

const state = {
  availableApps: null
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  async setCurrentApp ({ commit }, val) {
    localStorage.setItem('lastSelectedAppId', val)
    commit('SET_CURRENT_APP', val)
    const router = window['$router']
    const fp = router.currentRoute.fullPath
    if (val === 3 && fp !== '/cl') router.push('cl')
    if (val === 4 && fp !== '/sq') {
      router.push('sq')
      dispatch('suppliers/supplierTypesFetch', null, { root: true })
    }
    if (val === 6 && fp !== '/cr') router.push('cr')
    if (val === 7 && fp !== '/mcc') router.push('mcc')
    if (val === 8 && fp !== '/ia') router.push('ia')
    if (val === 11 && fp !== '/cc') router.push('cc')
  }
}

export default { state, mutations, namespaced, actions }
